import type {
  ComponentPropsWithRef,
  CSSProperties,
  KeyboardEvent,
  ReactNode,
} from 'react';

export type InputT = {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  sizeType?: SizeType;
  initFocus?: boolean;
  hideBorder?: boolean;
  useBlur?: boolean;
  onEnter?: (searchValue: string, e: KeyboardEvent<HTMLInputElement>) => void;
  onEscape?: () => void;
  wrapperStyle?: CSSProperties;
  css?: StyledCss;
} & ComponentPropsWithRef<'input'>;

export const FontSize = {
  xs: 10,
  s: 12,
  m: 14,
  l: 16,
  xl: 18,
};

export const HeightSize = {
  xs: 20,
  s: 24,
  m: 32,
  l: 40,
  xl: 48,
};
